import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const VenueCard = ({ venue, index = 0 }) => {
  return (
    <Link
      to={`/venues/${venue.id}`}
      className="block brutal-card overflow-hidden fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`venue-card-${venue.id}`}
    >
      <div className="relative h-36 overflow-hidden border-b-2 border-[#0A0A0A]">
        <img src={venue.image} alt={venue.name} className="w-full h-full object-cover" />
        <span className="absolute top-3 left-3 brutal-border bg-white rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wide">
          {venue.category}
        </span>
        {venue.deal && (
          <div
            className="absolute bottom-3 right-3 brutal-border px-3 py-1 rounded-md font-bold text-xs uppercase rotate-[-2deg]"
            style={{ background: venue.deal.color, boxShadow: "2px 2px 0px 0px #0A0A0A" }}
          >
            {venue.deal.label}
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading font-bold text-lg leading-tight">{venue.name}</h3>
        <div className="flex items-center gap-1 text-xs text-[#555555] mt-1">
          <MapPin className="w-3.5 h-3.5" />
          <span>{venue.address}</span>
          <span>•</span>
          <span className="font-bold text-[#0A0A0A]">{venue.distance_km} km</span>
        </div>
      </div>
    </Link>
  );
};

export default VenueCard;
